import { createSlice } from '@reduxjs/toolkit'

export const kybNotificationsV2Slice = createSlice({
  name: 'kybNotificationsV2',
  initialState: {
    filters: {
      page: 0,
      limit: 25,
      offset: 0,
      fromDate: null,
      type: 'BUSINESS',
    },
  },
  reducers: {
    updateKybNotificationsV2Filters: (state, action) => {
      state.filters = action.payload
    },
  },
})

export const { updateKybNotificationsV2Filters } = kybNotificationsV2Slice.actions
export default kybNotificationsV2Slice.reducer
